export const SITE = {
  name: "VacanzaGo",
  tagline: "Your Travel Guide",
  since: 2016,
  city: "Haridwar, Uttarakhand",
  phone: "+91 82170 05513",
  phoneRaw: "918217005513",
  email: "info@vacanzago.com",
  whatsapp: "918217005513",
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_travel-cms-hub-5/artifacts/2ilf7odo_Final%20LOGO.png",
  mapEmbed:
    "https://www.google.com/maps?q=Vacanza+Go,Haridwar&z=16&output=embed",
  mapLink:
    "https://www.google.com/maps/place/Vacanza+Go/@29.9476595,78.1590424,17z",
};

export function waLink(text) {
  const msg = encodeURIComponent(
    text || "Hi Vacanza Go, I came from your website and would like to plan a journey."
  );
  return `https://wa.me/${SITE.whatsapp}?text=${msg}`;
}

export const IMAGES = {
  heroSunrise:
    "https://images.unsplash.com/photo-1595815771614-ade9d652a65d?fm=webp&crop=entropy&cs=srgb&q=85&w=2000",
  heroMountain:
    "https://images.unsplash.com/photo-1635255506105-b74adbd94026?fm=webp&crop=entropy&cs=srgb&q=85&w=2000",
  heroJourney:
    "https://images.pexels.com/photos/29494184/pexels-photo-29494184.jpeg?auto=compress&cs=tinysrgb&w=2000",
  heroExperience:
    "https://images.pexels.com/photos/16617762/pexels-photo-16617762.jpeg?auto=compress&cs=tinysrgb&w=2000",
  heroGolden:
    "https://images.pexels.com/photos/8037061/pexels-photo-8037061.jpeg?auto=compress&cs=tinysrgb&w=2000",
  heroNight:
    "https://images.unsplash.com/photo-1772127822562-a898d9f5733c?fm=webp&crop=entropy&cs=srgb&q=85&w=2000",
  eventMandap:
    "https://images.pexels.com/photos/34079355/pexels-photo-34079355.jpeg?auto=compress&cs=tinysrgb&w=1600",
  eventCandles:
    "https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?fm=webp&crop=entropy&cs=srgb&q=85&w=1600",
  eventDining:
    "https://images.pexels.com/photos/36028957/pexels-photo-36028957.jpeg?auto=compress&cs=tinysrgb&w=1600",
  eventFloral:
    "https://images.unsplash.com/photo-1560505605-f300b17028d6?fm=webp&crop=entropy&cs=srgb&q=85&w=1600",
  taj:
    "https://images.unsplash.com/photo-1585506942812-e72b29cef752?fm=webp&crop=entropy&cs=srgb&q=85&w=1600",
  varanasi:
    "https://images.pexels.com/photos/27670662/pexels-photo-27670662.jpeg?auto=compress&cs=tinysrgb&w=1600",
  kedarnath:
    "https://images.pexels.com/photos/14149541/pexels-photo-14149541.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const DESTINATIONS = [
  { name: "Kashmir", region: "Jammu & Kashmir", line: "Where the mountains slow everything down.", img: IMAGES.heroSunrise },
  { name: "Leh Ladakh", region: "Ladakh", line: "Land of high passes and impossible blues.", img: IMAGES.heroMountain },
  { name: "Uttarakhand", region: "Char Dham & Himalaya", line: "Four sacred shrines, one storied river.", img: IMAGES.kedarnath },
  { name: "Himachal", region: "Shimla · Manali · Spiti", line: "The other Tibet, inside India.", img: IMAGES.heroJourney },
  { name: "Goa", region: "Coastal India", line: "Sun, sea and a slower pace.", img: IMAGES.heroGolden },
  { name: "Varanasi", region: "Uttar Pradesh", line: "A journey through India's spiritual heart.", img: IMAGES.varanasi },
];

export const EVENT_SERVICES = [
  { title: "Puja & Cultural Rituals", desc: "From an intimate home puja to a temple ceremony — décor, priests, prasad and flow, handled." },
  { title: "Destination Weddings", desc: "Full-scale weddings across palaces, resorts and hill venues — planned end to end." },
  { title: "Engagement · Haldi · Mehndi · Sangeet", desc: "Every pre-wedding function, styled and choreographed with a signature theme." },
  { title: "Bridal Makeup & Styling", desc: "On-call artists and stylists for the couple, family and the whole entourage." },
  { title: "Photography & Cinematography", desc: "Photo, video, drone coverage and polished edits — teasers to full films." },
  { title: "Bespoke Décor & Florals", desc: "Stages, mandaps, floral sculptures and thematic sets built to your story." },
  { title: "Catering & Dining", desc: "Multi-cuisine spreads, live counters and curated menus for every palate." },
  { title: "Corporate Events & MICE", desc: "Offsites, conferences, award nights and annual functions, produced professionally." },
  { title: "Birthdays & Anniversaries", desc: "Milestone celebrations — themes, entertainment, cake and every little touch." },
  { title: "Guest Travel & Stay", desc: "Accommodation blocks, transfers and hospitality desks for out-of-town guests." },
];

export const CATEGORY_LABELS = {
  pilgrimage: "Pilgrimage",
  himalayan: "Himalayan",
  leisure: "Leisure",
  heritage: "Heritage",
  offbeat: "Offbeat",
  beach: "Beach",
};

export const FAQS = [
  { q: "Where are you based and where do you operate?", a: "We're headquartered in Haridwar, Uttarakhand and have run Char Dham, Kedarnath, Badrinath and the wider Uttarakhand circuit since 2016. We also operate across Kashmir, Ladakh, Himachal (Shimla, Manali, Spiti), Goa, Sikkim, Rajasthan and the pan-India pilgrimage routes." },
  { q: "How do I confirm my booking?", a: "30% advance confirms your slot. 60% is due on Day 1 of the tour at the first hotel. The final 10% is settled during the trip (by Day 3). We accept UPI, NEFT and RTGS — full bank details are shared once you confirm." },
  { q: "How early should I book?", a: "For Char Dham (May–Oct) and Amarnath (Jul–Aug), book 4–6 weeks ahead. For Kailash Mansarovar, 4–6 months ahead. For Kashmir, Ladakh and Goa peak season, 3–4 weeks ahead. Last-minute trips are possible — just WhatsApp us." },
  { q: "What's the cancellation policy?", a: "45+ days before check-in: 5% retention. 30–44 days: 15%. 16–29 days: 25%. 7–15 days: 50%. 4–6 days: 75%. Within 72 hours / no-show: 100%." },
  { q: "Do you handle events as well as travel?", a: "Yes. Our Event Management vertical handles everything from an intimate puja to a full destination wedding or corporate event — décor, catering, makeup, photography, entertainment and guest logistics." },
];
